import { Link, useLocation } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { chromeCopy } from './chrome'
import { getLocaleFromPathname, hreflangFor, LOCALE_META, SITE_LOCALES, switchLocale } from './locale'

export function LanguageSwitcher({
  className,
  overInk = false,
  compact = false,
}: {
  className?: string
  overInk?: boolean
  compact?: boolean
}) {
  const { pathname } = useLocation()
  const current = getLocaleFromPathname(pathname)

  return (
    <nav
      aria-label={chromeCopy[current].language}
      dir="ltr"
      className={cn('flex items-center', className)}
    >
      {SITE_LOCALES.map((locale, index) => {
        const active = locale === current
        return (
          <span key={locale} className="flex items-center">
            {index > 0 ? (
              <span className={cn('px-0.5 text-[10px]', overInk ? 'text-white/40' : 'text-fw-muted')} aria-hidden>
                /
              </span>
            ) : null}
            <Link
              to={switchLocale(pathname, locale)}
              hrefLang={hreflangFor(pathname, locale)}
              lang={LOCALE_META[locale].htmlLang}
              aria-current={active ? 'page' : undefined}
              aria-label={LOCALE_META[locale].nativeLabel}
              title={LOCALE_META[locale].nativeLabel}
              className={cn(
                'inline-flex min-h-11 min-w-11 items-center justify-center font-fwmono text-[10px] font-medium uppercase tracking-[0.14em]',
                compact && 'min-h-9 min-w-9',
                active
                  ? overInk
                    ? 'font-semibold text-white'
                    : 'font-semibold text-fw-ink'
                  : overInk
                    ? 'text-fw-ink-body hover:text-white'
                    : 'text-fw-graphite hover:text-fw-ink',
              )}
            >
              {LOCALE_META[locale].label}
            </Link>
          </span>
        )
      })}
    </nav>
  )
}
